import { render, staticRenderFns } from "./external_content.vue?vue&type=template&id=a3889202"
import script from "./external_content.vue?vue&type=script&lang=js"
export * from "./external_content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports